import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M5 20H19V18H5V20ZM19 9H15V3H9V9H5L12 16L19 9Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Download"
);
